export const coPricePeriod = [
  { key: 1, min: 1, max: 50000, lable: "0-50,000" },
  { key: 2, min: 50000, max: 100000, lable: "50,000-100,000" },
  { key: 3, min: 100000, max: 200000, lable: "100,000-200,000" },
  { key: 4, min: 200000, max: 300000, lable: "200,000-300,000" },
  { key: 5, min: 300000, max: 400000, lable: "300,000-400,000" },
  { key: 6, min: 400000, max: 500000, lable: "400,000-500,000" },
  { key: 7, min: 500000, max: 9999999999999, lable: "มากกว่า 500,000" },
];
